// src/screens/admin/OrderListScreen.js
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Badge, Card, Row, Col } from 'react-bootstrap';
import { FaTimes, FaCheck, FaShoppingCart, FaUsers } from 'react-icons/fa';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetOrdersQuery } from '../../slices/ordersApiSlice';

const OrderListScreen = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  
  const { 
    data: orders, 
    isLoading, 
    error 
  } = useGetOrdersQuery(undefined, {
    skip: !userInfo || !userInfo.isAdmin,
  });

  useEffect(() => {
    if (!userInfo || !userInfo.isAdmin) {
      navigate('/login');
    }
  }, [userInfo, navigate]);

  // Calcul des statistiques (sans chiffre d'affaires)
  const stats = {
    totalOrders: orders?.length || 0,
    paidOrders: orders?.filter(order => order.isPaid).length || 0,
    pendingOrders: orders?.filter(order => !order.isPaid).length || 0,
  };

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <Message variant='danger'>{error?.data?.message || error.error}</Message>;
  }

  return (
    <div className="container mt-4">
      {/* En-tête avec statistiques */}
      <div className="mb-4">
        <h1>Tableau de Bord - Commandes</h1>
        <p className="text-muted">Vue d'ensemble de toutes les commandes du système</p>
      </div>

      {/* Cartes de statistiques SANS chiffre d'affaires */}
      <Row className="mb-4">
        <Col md={4} className="mb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body className="text-center">
              <FaShoppingCart className="text-primary mb-2" size={24} />
              <h4>{stats.totalOrders}</h4>
              <small className="text-muted">Total Commandes</small>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body className="text-center">
              <FaCheck className="text-success mb-2" size={24} />
              <h4>{stats.paidOrders}</h4>
              <small className="text-muted">Commandes Payées</small>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body className="text-center">
              <FaTimes className="text-warning mb-2" size={24} />
              <h4>{stats.pendingOrders}</h4>
              <small className="text-muted">En Attente</small>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Tableau des commandes */}
      <Card className="shadow-sm">
        <Card.Header className="bg-dark text-white d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <FaUsers className="me-2" />
            Liste des Commandes
          </h5>
          <Badge bg="light" text="dark" className="fs-6">
            {stats.totalOrders} commandes
          </Badge>
        </Card.Header>
        
        <Card.Body>
          {orders && orders.length > 0 ? (
            <div className="table-responsive">
              <Table striped bordered hover className='table-sm'>
                <thead className="table-dark">
                  <tr>
                    <th>ID</th>
                    <th>Utilisateur</th>
                    <th>Date</th>
                    <th>Total</th>
                    <th>Payé</th>
                    <th>Méthode</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => (
                    <tr key={order._id}>
                      <td>{order._id}</td>
                      <td>{order.user && order.user.name}</td>
                      <td>{order.createdAt.substring(0, 10)}</td>
                      <td>${order.totalPrice}</td>
                      <td>
                        {order.isPaid ? (
                          order.paidAt.substring(0, 10)
                        ) : (
                          <FaTimes style={{ color: 'red' }} />
                        )}
                      </td>
                      <td>{order.paymentMethod}</td>
                      <td>
                        {/* ✅ CORRECTION : Même lien que OrderListScreenOffice.js */}
                        <Link to={`/order${order.paymentMethod}/${order._id}`}>
                          <Button className='btn-sm' variant='light'>
                            Détails
                          </Button>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <Message variant="info" className="text-center py-4">
              <FaShoppingCart size={32} className="mb-3 opacity-50" />
              <h5>Aucune commande trouvée</h5>
              <p className="mb-0">Aucune commande n'a été passée pour le moment.</p>
            </Message>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default OrderListScreen;